import { isNullable } from '@app/utils'

import type { ObjectType } from './types'

export const objectHasEveryNullableProperties = (object: ObjectType): boolean => {
  return Object.values(object).every(isNullable)
}
